import { useEffect } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Experience from "@/components/Experience";
import PriceBreakdown from "@/components/PriceBreakdown";
import BookingSection from "@/components/BookingSection";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import MobileCTA from "@/components/MobileCTA";

export default function LandingPage() {
  useEffect(() => {
    // Smooth scroll polyfill for anchor links
    const handleClick = (e) => {
      const target = e.target.closest('a[href^="#"]');
      if (target) {
        e.preventDefault();
        const id = target.getAttribute("href").slice(1);
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  return (
    <div className="min-h-screen bg-[#0d0b09]">
      <Header />
      <Hero />
      <Marquee />
      <Experience />
      <PriceBreakdown />
      <BookingSection />
      <FAQ />
      <Footer />
      <MobileCTA />
    </div>
  );
}
